import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Share } from '@ifeng-fe/ui_pc_share';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { getShangxunList, getCommentCounts } from '../../../../../services/api';
class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        feedDataList: [],
        noData: false,
    };

    async componentDidMount() {
        const { content } = this.props;
        const feedUrlArr = content.map(item => item.commentUri);
        const commentNumArr = await getCommentCounts(feedUrlArr);

        commentNumArr.forEach((item, index) => {
            content[index].commentNum = item.allcount;
        });
        const dataPage1 = this.state.feedDataList.concat(content);

        this.setState(
            {
                feedDataList: dataPage1,
            },
            () => {
                this.scrollFeed();
            },
        );
    }

    scrollFeed() {
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        const pageSize = 30;
        let isLoadingData = false;
        let pageNum = 2;

        window.addEventListener(
            'scroll',
            async () => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
                const pageHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

                if (this.state.noData) return false;
                if (scrollHeight + windowHeight >= pageHeight - 50 && !isLoadingData) {
                    isLoadingData = true;
                    const dataNew = await getShangxunList(pageSize, pageNum);

                    if (dataNew) {
                        if (dataNew.length < pageNum) {
                            const feedDataListNew = this.state.feedDataList.concat(dataNew);

                            this.setState(
                                {
                                    feedDataList: feedDataListNew,
                                    noData: true,
                                },
                                () => {
                                    isLoadingData = false;
                                },
                            );
                        } else {
                            const feedDataListNew = this.state.feedDataList.concat(dataNew);

                            this.setState(
                                {
                                    feedDataList: feedDataListNew,
                                },
                                () => {
                                    isLoadingData = false;
                                },
                            );
                        }
                        pageNum++;
                    } else {
                        isLoadingData = false;
                    }
                }
            },
            false,
        );
    }
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { feedDataList, noData } = this.state;

        const config = {
            items: ['sina', 'qqzone'],
            display: 'normal',
            hover: 'hover',
            type: 'vertical',
            methods: 'hover',
            tooltip: 'top',
        };

        const feedListHtml = feedDataList.map((item, index) => (
            <div className={styles.news_div} key={index}>
                <h2 className={styles.title}>
                    <a href={item.url} rel={rel} target="_blank">
                        {item.title}
                    </a>
                </h2>
                {item.thumbnails && (
                    <div className={styles.news_img}>
                        <a href={item.url} rel={rel} target="_blank">
                            <img src={item.thumbnails} alt={item.title} />
                        </a>
                    </div>
                )}
                <div className={styles.news_info}>
                    <p className={styles.news_desc}>
                        <span dangerouslySetInnerHTML={{ __html: item.summary }} />[<a
                            href={item.url}
                            rel={rel}
                            target="_blank">
                            详细
                        </a>]
                    </p>
                    <div className={styles.news_time}>
                        {item.newsTime}
                        <span className={styles.comments}>
                            <a href={item.commentUrl}>评论{item.commentNum}</a>
                        </span>
                        <span className={styles.share}>
                            分享
                            <div className={styles.sharebox}>
                                <Share
                                    config={config}
                                    shareInfo={{
                                        url: item.url,
                                        title: item.title,
                                        summery: item.summary,
                                        picUrl: item.thumbnailsCount > 0 ? item.thumbnails.image[0].url : '',
                                    }}
                                />
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        ));

        return (
            <div className={styles.col_d_left}>
                <div className={styles.feedList}>
                    {feedListHtml}
                    {!noData && (
                        <div id="feedLoadIcon" className={styles.loading_div}>
                            <span className={styles.loading_icon} />
                            <p>亲爱的，下拉刷新更多精彩~~</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Banner);
